export const TRANSLATIONS = {
    EN: {
        LIQUIDATION: {
            REVIEW_APPLICATION: {
                CLIENT: {
                    TITLE: 'Review application',
                    DESCRIPTION: '',
                },
            },
            EDIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Your application is being processed',
                    DESCRIPTION:
                        '{service_provider} is preparing the documents. We will keep you informed about the status of the liquidation. If you need to take action, you will be notified by email. So please keep an eye on your mailbox. You will receive a message with the next steps within 5 working days.',
                    TEXT_1: 'Next steps of the liquidation:',
                    LIST: {
                        ITEM_1: '{service_provider} is preparing your documents',
                        ITEM_2: 'Please review and sign the CoC form and the resolution to liquidate',
                        ITEM_3: 'Send the documents by registered mail',
                        ITEM_4: 'The documents are being reviewed',
                        ITEM_5: 'The documents have been approved and sent to the Chamber of Commerce',
                        ITEM_6: '{company} is deregistered.',
                    },
                },
                SUPPORT: {
                    TITLE: 'Your application is being processed',
                },
            },
            WAIT_FOR_PREPARE_SIGNING: {
                CLICK_TO_PREPARE: 'Prepare document',
                CLIENT: {
                    TITLE: 'Wait for prepare signing',
                    DESCRIPTION:
                        '{tenant} will prepare the signing of the documents. You will receive a notification by e-mail as soon as these documents are ready in your dashboard.',
                },
                NOTARY: {
                    TITLE: 'Wait for prepare signing',
                    DESCRIPTION:
                        'Wait for signing the documents by the shareholders. Uploaded the wrong document? Easily adjust the document and upload the correct one.',
                },
                SUPPORT: {
                    TITLE: 'Wait for prepare signing',
                    DESCRIPTION:
                        'Wait for signing the documents by the shareholders. Uploaded the wrong document? Easily adjust the document and upload the correct one.',
                },
            },
            WAIT_FOR_SIGNING: {
                CLIENT: {
                    TITLE: 'Signing power of attorney',
                    DESCRIPTION:
                        'The liquidation resolution has been drafted and is ready for signing. An email invitation has been sent to the appropriate shareholder(s) to digitally sign the liquidation resolution.',
                },
                NOTARY: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                    DESCRIPTION: 'The client will view and sign the liquidation resolution.',
                },
                SUPPORT: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                    DESCRIPTION: 'The client will view and sign the liquidation resolution.',
                },
            },
            SIGN_BY_HAND: {
                CLIENT: {
                    TITLE: 'Send documents to {service_provider}',
                    DESCRIPTION: 'Download, print, sign and send the delivered documents by post to',
                },
                SUPPORT: {
                    TITLE: 'Wait for signed documents',
                    DESCRIPTION: 'Print, sign and send the delivered documents by post to',
                },
                NOTARY: {
                    TITLE: 'Wait for signed documents',
                    DESCRIPTION: 'Print, sign and send the delivered documents by post to',
                },
                BOOKKEEPER: {
                    TITLE: 'Send documents to {service_provider}',
                    DESCRIPTION: 'Download, print, sign and send the delivered documents by post to',
                },
            },
            APPROVE_DOCUMENT: {
                CLIENT: {
                    TITLE: 'Wait for confirmation by {service_provider}',
                    DESCRIPTION: '',
                    TEXT_1: 'Your documents are being reviewed by {service_provider}. If something is incorrect, our support team will contact you. You will receive a confirmation when the application is sent to the Chamber of Commerce.',
                    TEXT_2: 'After the documents have been received by the Chamber of Commerce, it takes up to 10 working days for the deregistration request to be processed by the Chamber of Commerce. After the company has been deregistered from the Chamber of Commerce, you will receive a confirmation of this by email. The date of deregistration is the termination date on the documents. This is therefore backdated.',
                },
                NOTARY: {
                    TITLE: 'Send documents to Chamber of Commerce',
                },
                SUPPORT: {
                    TITLE: 'Send documents to Chamber of Commerce',
                },
                BOOKKEEPER: {
                    TITLE: 'Wait for confirmation by {service_provider}',
                    DESCRIPTION: '',
                },
            },
            DEREGISTER_COMPANY: {
                CLIENT: {
                    TITLE: 'Wait for confirmation of deregistration by the Chamber of Commerce',
                    DESCRIPTION: 'The company {company} is being deregistered.',
                    TEXT_1: 'The deregistration file has been sent to the Chamber of Commerce. The Chamber will process the deregistration request within a maximum of 10 working days.',
                    TEXT_2: 'After the company has been deregistered from the Chamber of Commerce, you will receive confirmation of this by e-mail. The date of deregistration is the dissolution date on the documents. This is therefore retroactive.',
                },
                SUPPORT: {
                    TITLE: 'Wait for confirmation of deregistration by the Chamber of Commerce',
                },
            },
            SUCCESSFUL: {
                CLIENT: {
                    TITLE: 'Procedure completed',
                    TEXT_1: 'Congratulations, {company} is deregistered from the Chamber of Commerce.',
                    TEXT_2: 'Be aware that:',
                    TEXT_3: 'This director becomes "keeper of the books" of the company, and must keep the administration for 7 years.',
                    TEXT_4: 'We recommend that you keep a copy of the signed documents for your own records.',
                },
                SUPPORT: {
                    TITLE: 'Procedure completed',
                },
            },
            ERRORS: {
                ERROR_ACCOUNT_NOT_FILLED:
                    'Unfortunately, it is not possible to apply for the turbo liquidation before the accounting for the current financial year is available and up to date. First ensure that the accounting is updated and available and then request the turbo liquidation again.',
                ERROR_NO_BALANCE_SHEET_FISCAL_YEAR:
                    'Unfortunately, it is not possible to apply for the turbo liquidation before the accounting for the current financial year is available and up to date. First ensure that the accounting is updated and available and then request the turbo liquidation again.',
            },
        },
    },
    NL: {
        LIQUIDATION: {
            REVIEW_APPLICATION: {
                CLIENT: {
                    TITLE: 'Aanvraag beoordelen',
                    DESCRIPTION: '',
                },
            },
            EDIT_DETAILS: {
                CLIENT: {
                    TITLE: 'Jouw aanvraag is in behandeling',
                    DESCRIPTION:
                        '{service_provider} bereidt de documenten voor. Wij houden je op de hoogte over de status van de opheffing. Als je actie moet ondernemen, wordt je hiervan per e-mail op de hoogte gesteld. Houd daarom jouw mailbox in de gaten. Binnen 5 werkdagen ontvang je een bericht met de vervolgstappen.',
                    TEXT_1: 'Volgende stappen van de opheffing:',
                    LIST: {
                        ITEM_1: '{service_provider} bereidt de documenten voor',
                        ITEM_2: 'Gelieve het KvK-formulier en het besluit tot liquidatie door te nemen en te ondertekenen met pen.',
                        ITEM_3: 'Verstuur de documenten aangetekend.',
                        ITEM_4: 'De documenten worden beoordeeld.',
                        ITEM_5: 'De documenten zijn goedgekeurd en verzonden naar de Kamer van Koophandel.',
                        ITEM_6: '{company} is uitgeschreven.',
                    },
                },
                SUPPORT: {
                    TITLE: 'Jouw aanvraag is in behandeling',
                },
            },
            WAIT_FOR_PREPARE_SIGNING: {
                CLICK_TO_PREPARE: 'Bereid het document voor',
                CLIENT: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                    DESCRIPTION:
                        '{tenant} is de documenten aan het voorbereiden voor ondertekening. Je ontvangt per e-mail een notificatie zodra deze documenten klaar staan in jouw dashboard.',
                },
                NOTARY: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                    DESCRIPTION:
                        'Wacht op ondertekening door de aandeelhouders. Verkeerde document geupload? Verwijder eenvoudig het document aan en upload de correcte versie.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op voorbereiden ondertekening',
                    DESCRIPTION:
                        'Wacht op ondertekening door de aandeelhouders. Verkeerde document geupload? Verwijder eenvoudig het document aan en upload de correcte versie.',
                },
            },
            WAIT_FOR_SIGNING: {
                CLIENT: {
                    TITLE: 'Ondertekening volmacht',
                    DESCRIPTION:
                        'Het liquidatiebesluit is opgesteld en staat klaar voor ondertekening. Er is een uitnodiging per email gestuurd naar de betreffende aandeelhouder(s) om het liquidatiebesluit digitaal te ondertekenen.',
                },
                NOTARY: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                    DESCRIPTION: 'De klant bekijkt en ondertekent het liquidatiebesluit.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                    DESCRIPTION: 'De klant bekijkt en ondertekent het liquidatiebesluit.',
                },
            },
            SIGN_BY_HAND: {
                CLIENT: {
                    TITLE: 'Verstuur documenten naar {service_provider}',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar',
                },
                SUPPORT: {
                    TITLE: 'Wacht op ondertekende documenten',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar',
                },
                NOTARY: {
                    TITLE: 'Wacht op ondertekende documenten',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar',
                },
                BOOKKEEPER: {
                    TITLE: 'Verstuur documenten naar {service_provider}',
                    DESCRIPTION: 'Print, onderteken en stuur de geleverde stukken per post op naar',
                },
            },
            APPROVE_DOCUMENT: {
                CLIENT: {
                    TITLE: 'Wacht op bevestiging door {service_provider}',
                    DESCRIPTION: '',
                    TEXT_1: 'De documenten worden beoordeeld door {service_provider}. Als er iets niet klopt, wordt er contact met je opgenomen. Je ontvangt een bevestiging wanneer de aanvraag naar de Kamer van Koophandel wordt gestuurd.',
                    TEXT_2: 'Nadat de stukken door de KvK zijn ontvangen, duurt het maximaal 10 werkdagen voordat het verzoek tot uitschrijving is verwerkt door de KvK. Nadat de onderneming is uitgeschreven uit de KvK, ontvang je een bevestiging per e-mail hiervan. De datum van uitschrijving is de opheffingsdatum op de documenten. Dit gebeurt dus met terugwerkende kracht.',
                },
                SUPPORT: {
                    TITLE: 'Documenten versturen naar KvK',
                },
                NOTARY: {
                    TITLE: 'Documenten versturen naar KvK',
                },
                BOOKKEEPER: {
                    TITLE: 'Wacht op bevestiging door {service_provider}',
                },
            },
            DEREGISTER_COMPANY: {
                CLIENT: {
                    TITLE: 'Wacht op bevestiging uitschrijving door de KvK',
                    DESCRIPTION: 'Het bedrijf {company} wordt uitgeschreven.',
                    TEXT_1: 'Het opheffingsdossier is opgestuurd naar de Kamer van Koophandel. Deze zal verzoek tot uitschrijving verwerken in maximaal 10 werkdagen. Als er iets niet klopt bij het dossier, dan wordt er contact met je opgenomen.',
                    TEXT_2: 'Nadat de onderneming is uitgeschreven uit de KvK, ontvang je een bevestiging per e-mail hiervan. De datum van uitschrijving is de opheffingsdatum op de documenten. Dit gebeurt dus met terugwerkende kracht.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op bevestiging uitschrijving door de KvK',
                },
            },
            SUCCESSFUL: {
                CLIENT: {
                    TITLE: 'Procedure voltooid',
                    TEXT_1: 'Gefeliciteerd, {company} is uitgeschreven bij de KvK.',
                    TEXT_2: 'Let op:',
                    TEXT_3: 'De directeur wordt "bewaarder" van de vennootschap en moet de administratie 7 jaar bewaren.',
                    TEXT_4: 'Wij raden u aan een kopie van de ondertekende documenten te bewaren voor uw eigen administratie.',
                },
                SUPPORT: {
                    TITLE: 'Procedure voltooid',
                },
            },
            ERRORS: {
                ERROR_ACCOUNT_NOT_FILLED:
                    'Helaas is het niet mogelijk om de aanvraag voor de turboliquidatie aan te vragen voordat alle jaarrekeningen zijn gedeponeerd bij de KvK. Deponeer eerst alle jaarrekeningen bij de Kamer van Koophandel en vraag daarna de turboliquidatie aan.',
                ERROR_NO_BALANCE_SHEET_FISCAL_YEAR:
                    'Helaas is het niet mogelijk om de aanvraag voor de turboliquidatie aan te vragen voordat de boekhouding voor het lopende boekjaar beschikbaar en up-to-date is. Zorg eerst dat de boekhouding is bijgewerkt en beschikbaar is en vraag daarna opnieuw de turboliquidatie aan.',
            },
        },
    },
};
